import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'
import { cn } from '../../Utils/component'
import { getRandomPrimaryColor } from '../../constants'

export type HeaderMediaProps = {
  headerMediaImage: string | IGatsbyImageData | null
  tool?: boolean
  colorCareerSite?: string
}

const HeaderMedia: React.FC<HeaderMediaProps> = ({
  headerMediaImage,
  tool = false,
  colorCareerSite = undefined,
}) => {
  const colorToDisplay = useMemo(
    () => (colorCareerSite ? undefined : getRandomPrimaryColor()),
    [colorCareerSite],
  )

  const classNames = useMemo(() => {
    if (tool) {
      return 'lg:h-96 h-96 w-screen brightness-[0.3]'
    }

    return 'h-[calc(100vh-12rem)] md:h-[calc(100vh-20rem)] lg:h-96 w-screen brightness-[0.3]'
  }, [tool])

  if (
    headerMediaImage &&
    typeof headerMediaImage !== 'string' &&
    'images' in headerMediaImage
  ) {
    return (
      <div data-testid="header-media-container">
        <GatsbyImage
          image={headerMediaImage as IGatsbyImageData}
          alt="header"
          className={classNames}
        />
      </div>
    )
  }

  if (typeof headerMediaImage === 'string') {
    return (
      <div data-testid="header-media-container" className="w-screen">
        <img
          src={headerMediaImage}
          alt="header"
          className={cn(
            classNames,
            'object-cover object-center',
          )}
        />
      </div>
    )
  }

  return (
    <div data-testid="header-media-container">
      <div
        data-testid="header-media-background"
        className={cn(
          classNames,
          'object-contain',
          colorToDisplay && `bg-${colorToDisplay}`,
        )}
        style={{
          backgroundColor: colorCareerSite,
        }}
      />
    </div>
  )
}

export default HeaderMedia
